export default "__VITE_ASSET__CU5wH70u__"